<template>
<el-upload :disabled="canEdit" multiple :action="uploadAction" :headers="uploadHeaders" :before-upload="fileValidate" :on-preview="openImageViewer" :file-list="fileList" :on-remove="onFileRemove" :on-success="
      (response, file, fileList) => onUploadSuccess(response, file, fileList)
    ">
    <el-button :disabled="canEdit" class="btn default" size="small">点击上传</el-button>
    <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
</el-upload>
</template>

<script>
import ElImageViewer from "@/components/elImageViewer";
// import { config } from "@/utils/config";
import {
    getToken
} from "@/utils/cookie";

export default {
    components: {
        ElImageViewer,
    },
    data() {
        return {
            // uploadAction: config.serverHost + "/FileInfo/FileUpload",
            uploadAction: config.FileUploadHost + "/FileInfo/FileUpload", // 推送服务的
            uploadHeaders: {
                Authorization: `Bearer ${getToken()} `,
            },
            fileId: 0,
            fileName: "",
            openViewer: false,
            fileList: [],
        };
    },
    props: {
        canEdit: {
            type: Boolean,
            default () {
                return true;
            },
        },
        oldList: {
            type: [Array,String],
            default () {
                return [];
            },
        },
        isLimitMaxSiz: {
            type: Boolean,
            default () {
                return false;
            },
        },
        // 默认最大图片大小
        defaultMaxSize: {
            type: Number,
            default () {
                return 15;
            },
        },
        // 默认文件类型  
        defaultType:{
            type: Array,
            default () {
                return ['png','jpg','jpeg','pdf'];
            },
        }
    },
  watch: {
    oldList(val, oldVal) {
      this.fileList = JSON.parse(JSON.stringify(this.oldList));
      if (!this.fileList) {
        this.fileList = [];
      }
    },
  },

  mounted() {
    //  this.$nextTick(()=>{
    //     this.fileList = JSON.parse(JSON.stringify(this.oldList));
    //   if (!this.fileList) {
    //     this.fileList = [];
    //   }
    //   console.log('图片',this.fileList)
    //  })
       
    },
    methods: {
        // 上传附件
        openImageViewer(e) {
            this.openViewer = true;
            if (e.percentage) {
                this.fileId = e.response.returnData[0].id;
                this.fileName = e.response.returnData[0].name;
            } else {
                this.fileId = e.id;
                this.fileName = e.name;
            }
        },
        closeImageViewer() {
            this.openViewer = false;
        },
        // 当上传完文件以后
        onUploadSuccess(response, file, fileList) {
            if (!this.fileList) {
                this.fileList = [];
            }

            this.fileList.push(...response.returnData);

            this.$emit("filesChange", this.fileList);
            console.log( this.fileList, "openImageViewer");
        },
        // 删除文件以后
        onFileRemove(file, fileList) {
            this.fileList = fileList;
            this.$emit("filesChange", this.fileList);
        },
        fileValidate(file) {
            const fileType = file.type.split('/')[1]
            console.log(file.type)
            if(this.defaultType.indexOf(fileType) == -1){
                this.$my_message(`不能上传${fileType}格式文件,上传失败！`, "warning");
                return false
            }

            if (!this.isLimitMaxSiz) {
                return true;
            }
            let size = 0;
            this.fileList.forEach((f) => {
                size += f.size;
            });

            if (size + file.size > (this.defaultMaxSize*1024*1024)) {
                this.$my_message(`文件总体内容大小超过${this.defaultMaxSize}M,上传失败！`, "warning");
                return false;
            }
        },
    },
};
</script>
